import React, { useState } from "react";

const MerchantBankDetails = ({ profileData }) => {
  const [formData, setFormData] = useState(profileData);
  const inputFields = [
    {
      name: "bankName",
      type: "select",
      label: "Bank Name",
      placeholder: "Bank Name",
    },
    {
      name: "accountHolderName",
      type: "tel",
      label: "Account Holder Name",
      placeholder: "Account Holder Name",
    },
    {
      name: "accountNumber",
      type: "tel",
      label: "Account Number",
      placeholder: "Account Number",
    },
    {
      name: "ifscCode",
      type: "text",
      label: "IFSC Code",
      placeholder: "IFSC Code",
    },
  ];

  return (
    <div className="pt-8">
      <form className="space-y-4 md:space-y-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-7">
          {inputFields.map((field) => (
            <div key={field.name}>
              <label
                htmlFor={field.name}
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-800"
              >
                {field.label}
              </label>

              <input
                type={field.type}
                name={field.name}
                id={field.name}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 focus:outline-none dark:placeholder-gray-400 dark:text-gray-800"
                placeholder={field.placeholder}
                value={
                  formData.bankDetails
                    ? formData.bankDetails[field.name]
                    : "N/A"
                }
              />
            </div>
          ))}
        </div>
        
      </form>
     
    </div>
  );
};

export default MerchantBankDetails;
